<div>
  <div class="upgrade-agent" *ngIf="formatData && !isLoading()">
    <div class="content">
      <div class="title">
        Choose an upgrade version:
        <mat-select
          class="option-list"
          [(ngModel)]="upgradeVersion"
          (ngModelChange)="ValidateSelectedAgents()"
        >
          <mat-option *ngFor="let version of availableVersions" [value]="version"
            >{{ version }}</mat-option
          >
        </mat-select>
      </div>
      <div class="message">
        <ul>
          <li class="message-block">
            <b>All tests will be stopped while agents are being upgraded.</b>
          </li>
          <li class="message-block">
            <b
              >Tests may take up to an hour to restart following the upgrade. Meanwhile, it can be
              started manually.</b
            >
          </li>
          <li class="message-block">
            <b>Before proceeding with the upgrade, ensure that port 80 is open if relevant.</b>
          </li>

          <li>{{upgradeMessage}}</li>
        </ul>
      </div>
      <div class="title">{{upgradeSelectionTitle}}</div>
      <mat-card class="card-content">
        <mat-grid-list class="header" cols="8" rowHeight="5rem">
          <mat-grid-tile colspan="1" rowspan="1"> </mat-grid-tile>
          <mat-grid-tile colspan="3" rowspan="1">
            <div class="text-inside-grid title">Name</div>
          </mat-grid-tile>
          <mat-grid-tile colspan="3" rowspan="1">
            <div class="text-inside-grid title">Version</div>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="8" rowHeight="5rem" *ngFor="let item of formatData">
          <mat-grid-tile colspan="1" rowspan="1">
            <logo-widget [defaultUrl]="item.icon" [styleInfo]="'table'"></logo-widget>
          </mat-grid-tile>
          <mat-grid-tile colspan="3" rowspan="1">
            <div class="text-inside-grid">{{item.name}}</div>
          </mat-grid-tile>
          <mat-grid-tile colspan="3" rowspan="1"
            ><div class="text-inside-grid">{{item.version}}</div></mat-grid-tile
          >
        </mat-grid-list>
      </mat-card>
    </div>
  </div>
  <div *ngIf="isLoading()" class="retry-container">
    <div class="label label--bold medium-margin">
      <p>Upgrading</p>
    </div>
    <mat-spinner [diameter]="60"></mat-spinner>
    <div class="label medium-margin">Initiating upgrade request...</div>
  </div>
</div>
